import React, { useState, useEffect, memo, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
// Importando componentes internos
import { Dialog, Drawer, BotaoContato } from "../components";
import LogoPDF from "../imagens/logo.png";
import SemFoto from "../imagens/sem_foto.png";
import SemFotoHomem from "../imagens/sem_foto_homem.jpeg";
//
import {
  Slider,
  Paper,
  Container,
  useTheme,
  Stack,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  IconButton,
  CircularProgress,
  TextField,
  ListItemAvatar,
  Pagination,
  Skeleton,
  Badge,
  Switch,
} from "@mui/material";
import {
  Card,
  CardContent,
  CardActions,
  Chip,
  Grid,
  Box,
  Button,
  Avatar,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import MaskedInput from "react-text-mask";
import { ToastContainer } from "react-toastify";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DateTimePicker from "@mui/lab/DateTimePicker";
// Icones
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import AirlineSeatReclineNormalIcon from "@mui/icons-material/AirlineSeatReclineNormal";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CakeIcon from "@mui/icons-material/Cake";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import SaveIcon from "@mui/icons-material/Save";
import GroupsIcon from "@mui/icons-material/Groups";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import DateRangeIcon from "@mui/icons-material/DateRange";
import ScheduleIcon from "@mui/icons-material/Schedule";
import EventIcon from "@mui/icons-material/Event";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import PersonIcon from "@mui/icons-material/Person";
import HomeIcon from "@mui/icons-material/Home";
import EmailIcon from "@mui/icons-material/Email";
import ChildFriendlyIcon from "@mui/icons-material/ChildFriendly";
import SchoolIcon from "@mui/icons-material/School";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import HistoryIcon from "@mui/icons-material/History";
//import DeleteIcon from '@mui/icons-material/Delete';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import WcIcon from "@mui/icons-material/Wc";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PlaceIcon from "@mui/icons-material/Place";
import CloseIcon from "@mui/icons-material/Close";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import WorkIcon from "@mui/icons-material/Work";

// Importando as actions usadas
import {
  curriculoGetDados,
  curriculoGetAgendaVencida,
  curriculoLimparAgendaVencida,
  curriculoAprovarReprovarReservarCandidato,
  curriculoRemoverCandidatoAgendaVencida,
  curriculoGetAgenda, // Recuperará a agenda seja do candidato quanto a dos outros
  curriculoRemoverCandidatoAgenda, // Para remover o candidato da agenda
  curriculoAddUpdCandidatoAgenda,
  curriculoGetDetalhesCurriculo,
  //curriculoGetDetalhesCurriculoLimpar,  // Para atualizar/inserir um candidato na agenda
  curriculoAddDelFavorito, // Para adicionar/remover dos favoritos
  curriculoGetListaDeEspera, // Para recuperar a lista de espera, tanto minha quanto dos outros
  //curriculoLimparListaDeEspera, // Para fechar a lista de espera
  curriculoGetHistorico, // Para ver o historico do curriculo
  //curriculoFecharHistorico, // Para fechar o historico do curriculo
  //curriculoRemoverCandidatoListaDeEspera, // Para remover o candidato da lista de espera
  curriculoLimparMinhaAgenda, // Para limpar a agenda
  curriculoGetCurriculoPorPagina, // Para obter os curriculos por pagina
  curriculoFiltroAvancadoAplicar, // Para aplicar o filtro na pagina
  curriculoFiltroAvancadoLimpar, // Para desativar o filtro aplicado a pagina
  curriculoSetDrawer,
  curriculoFecharDrawer,
} from "../redux/actions";
import { parseISO, format, subDays, addDays, isWithinInterval } from "date-fns";
import { ptBR } from "date-fns/locale";
import { motion, AnimatePresence } from "framer-motion";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { RetornoEmBranco } from "../components";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  ToastErro,
  formatarParaSelect,
  formatarTelefone,
} from "../utils/utils";
import {
  PDFDownloadLink,
  Image,
  Page,
  Document,
  StyleSheet,
  View,
  Text,
} from "@react-pdf/renderer";
import axios from "axios";

const animetedComponents = makeAnimated();
//
// Opcoes dos drawers
export const DRAWER = {
  CURRICULO_CRIAR_AGENDAMENTO: "CURRICULO_CRIAR_AGENDAMENTO",
  VER_FAVORITOS: "VER_FAVORITOS",
  VER_FORM_APLICAR_FILTRO: "VER_FORM_APLICAR_FILTRO",
  VER_AGENDA: "VER_AGENDA",
  VER_DOWNLOAD_PDF: "VER_DOWNLOAD_PDF",
  DETALHES_CURRICULO: "DETALHES_CURRICULO",
  VER_HISTORICO_CURRICULO: "VER_HISTORICO_CURRICULO",
  VER_LISTA_ESPERA: "VER_LISTA_ESPERA",
};

// Estilização do componente select
const selectStyles = {
  multiValueRemove: (styles) => ({
    ...styles,
    color: "black",
  }),
  option: (styles) => ({
    ...styles,
    color: "black",
  }),
};

// Criando estilizacao para o curriculo
const styleCurriculoPDF = StyleSheet.create({
  container: {
    paddingVertical: 8,
    paddingHorizontal: 8,
  },
  formaImagem: {
    width: 64.5,
    height: 86,
    borderColor: "lightgrey",
    borderWidth: 1,
    borderRadius: 4,
  },
  flexWrap: {
    flexDirection: "row",
    flexWrap: "wrap",
  },
  divider: {
    marginVertical: 2,
    borderBottomWidth: 1,
    borderBottomColor: "lightgrey",
  },
  backgroundTitulo: {
    padding: 2,
    marginVertical: 6,
    backgroundColor: "#ddd",
    borderRadius: 4,
  },
  cabe: {},
  image: {
    height: 27,
    width: 82,
  },
  nome: {
    fontSize: 14,
    fontWeight: "bold",
    lineHeight: 1.15,
    textAlign: "center",
    textTransform: "uppercase",
  },
  titulo: {
    fontSize: 12,
    fontWeight: "bold",
    lineHeight: 1.15,
    textAlign: "center",
    textTransform: "uppercase",
  },
  subTitulo: {
    fontSize: 10,
  },
  texto: {
    fontSize: 11,
    fontWeight: "bold",
    lineHeight: 1.25,
  },
  textoDisponibilidade: {
    marginVertical: 4,
    fontSize: 12,
    fontWeight: "bolder",
    lineHeight: 1.5,
  },
});
// Componente que gera o Curriculo em PDF
const PDFCurriculo = ({ dados }) => {
  return dados ? (
    <Document>
      <Page orientation="portrait" size="A4" style={styleCurriculoPDF.page}>
        <View style={styleCurriculoPDF.container}>
          <View style={styleCurriculoPDF.cabe}>
            <View>
              <Image
                style={styleCurriculoPDF.image}
                cache={false}
                source={LogoPDF}
              />
            </View>
            <View style={styleCurriculoPDF.divider} />
            <View>
              <Text style={styleCurriculoPDF.nome}>
                {dados.pessoal["Nome"]}
              </Text>
            </View>
            <View>
              <View style={styleCurriculoPDF.backgroundTitulo}>
                <Text style={styleCurriculoPDF.titulo}>DADOS PESSOAIS</Text>
              </View>
              <View style={{ flexDirection: "row" }}>
                <View style={{ flex: 1 }}>
                  <Text style={styleCurriculoPDF.texto}>
                    E-mail: {dados.pessoal["E-mail"]}
                  </Text>
                  <Text style={styleCurriculoPDF.texto}>
                    Idade: {dados.pessoal["Idade"]} anos
                  </Text>
                  <Text style={styleCurriculoPDF.texto}>
                    Celular: {formatarTelefone(dados.pessoal["Celular"])}
                  </Text>
                  <Text style={styleCurriculoPDF.texto}>
                    Sexo: {dados.pessoal["Sexo"]}
                  </Text>
                  <Text style={styleCurriculoPDF.texto}>
                    Estado Civil: {dados.pessoal["Estado civil"]}
                  </Text>

                  <Text style={styleCurriculoPDF.texto}>
                    Endereço:{" "}
                    {[
                      dados.pessoal["Endereco"],
                      dados.pessoal["Número"]
                        ? `n° ${dados.pessoal["Número"]}`
                        : "",
                      dados.pessoal["Complemento"],
                    ].join(", ")}
                  </Text>
                  <Text style={styleCurriculoPDF.texto}>
                    Bairro: {dados.pessoal["Bairro"]}
                  </Text>
                  <Text style={styleCurriculoPDF.texto}>
                    Cidade: {dados.pessoal["Cidade"]}
                  </Text>
                  <Text style={styleCurriculoPDF.texto}>
                    Estado: {dados.pessoal["estado"]}
                  </Text>
                </View>
                <View style={styleCurriculoPDF.formaImagem}>
                  <Image
                    source={
                      dados.pessoal["Sexo"] === "Masculino"
                        ? SemFotoHomem
                        : SemFoto
                    }
                  />
                </View>
              </View>
              <View style={styleCurriculoPDF.backgroundTitulo}>
                <Text style={styleCurriculoPDF.titulo}>FORMAÇÃO ACADÊMICA</Text>
              </View>
              <Text style={{ ...styleCurriculoPDF.texto, textAlign: "center" }}>
                Escolaridade: {dados.pessoal["Escolaridade"]}
              </Text>

              <View style={styleCurriculoPDF.backgroundTitulo}>
                <Text style={styleCurriculoPDF.titulo}>
                  EXPERIÊNCIAS PROFISSIONAIS
                </Text>
              </View>
              {dados.experiencia_profissional?.map((obj, idx) => {
                const { admissao, demissao, cargo, empresa, atividades } = obj;
                return (
                  <View style={{ marginVertical: 4 }} key={idx}>
                    <View
                      style={{
                        justifyContent: "space-between",
                        flexDirection: "row",
                      }}
                    >
                      <Text style={styleCurriculoPDF.texto}>
                        Admissão: {format(parseISO(admissao), "dd/MM/yyyy")}{" "}
                      </Text>
                      <Text style={styleCurriculoPDF.texto}>
                        Demissão: {format(parseISO(demissao), "dd/MM/yyyy")}{" "}
                      </Text>
                      <Text style={styleCurriculoPDF.texto}>
                        Cargo: {cargo}{" "}
                      </Text>
                    </View>
                    <View>
                      <Text style={styleCurriculoPDF.texto}>
                        Empresa: {empresa}{" "}
                      </Text>

                      <Text style={styleCurriculoPDF.texto}>
                        Atividades desempenhadas:
                      </Text>
                      <Text style={styleCurriculoPDF.texto}>{atividades}</Text>
                    </View>
                    <View style={styleCurriculoPDF.divider} />
                  </View>
                );
              })}

              <View style={styleCurriculoPDF.backgroundTitulo}>
                <Text style={styleCurriculoPDF.titulo}>
                  DISPONIBILIDADE PARA TRABALHAR
                </Text>
              </View>
              <View style={styleCurriculoPDF.flexWrap}>
                {dados.disponibilidade?.map((ele, idx) => {
                  const { regiao, localidade } = ele;
                  return (
                    <Text
                      key={idx}
                      style={{
                        ...styleCurriculoPDF.textoDisponibilidade,
                        flexBasis: "33%",
                      }}
                    >
                      {[regiao, localidade].join(" - ")}
                    </Text>
                  );
                })}
              </View>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  ) : (
    <></>
  );
};
// Componente que trabalhar-ra como um link para ativar o Download do curriculo em pdf
const BotaoPDF = ({ dados }) => {
  return (
    <PDFDownloadLink
      style={{ textDecoration: "none" }}
      document={<PDFCurriculo dados={dados} />}
      fileName="curriculo.pdf"
    >
      {({ blob, url, loading, error }) => (
        <Button
          title="Clique aqui para baixar uma versão completa do currículo em PDF"
          startIcon={<FileDownloadIcon />}
          variant="contained"
          size="small"
          color="primary"
        >
          BAIXAR CURRICULO PDF
        </Button>
      )}
    </PDFDownloadLink>
  );
};
//
const fnGetTexto = (status) => {
  switch (status) {
    case "A":
      return "APROVADO(A)";
    case "R":
      return "REPROVADO(A)";
    case "L":
      return "LISTA DE ESPERA";
    case "AG":
      return "AGENDA";
    default:
      return "";
  }
};
// Para saber o sexo
const fnGetSexo = (sexo) => {
  switch (sexo) {
    case "F":
      return "Feminino";
    default:
      return "Masculino";
  }
};
// Para ver qual icone usar baseado no sexo
const fnGetSexoIcone = (sexo) => {
  switch (sexo) {
    case "F":
      return <FemaleIcon />;
    default: // Masculino
      return <MaleIcon />;
  }
};
// Schema de validacao
const schemaValidacao = yup.object().shape({
  agenda: yup.date().min(new Date()).required(),
});

const Curriculo = () => {
  const dispatch = useDispatch();
  const curriculo = useSelector((state) => state.curriculo);
  const drawer = useSelector((state) => state.curriculo?.drawer);

  //const {curriculo} = useSelector(state=> state);
  //Chamada para buscar os dados iniciais da pagina de curriculos
  useEffect(() => dispatch(curriculoGetDados()), [dispatch]);
  // Chamada para buscar os curriculos agendados que o prazo ja venceu
  useEffect(() => dispatch(curriculoGetAgendaVencida()), [dispatch]);
  // Pegar a resolucao da tela para saber em qual estamos trabalhando
  const {
    breakpoints: { values },
  } = useTheme();
  const isMobile = values["sm"] > window.innerWidth;
  // Para controlar a exibicao do drawer (na verdade pode ser um drawer ou dialog)
  //const [exibirDrawer, setExibirDrawer] = useState(null);

  // Criando funcao para fechar o Drawer
  let fnFecharDrawer = () => {
    //setExibirDrawer(false); // Fecha o drawer|dialog
    dispatch(curriculoLimparAgendaVencida());
    dispatch(curriculoLimparMinhaAgenda()); // Para limpar a agenda aberta
  };

  //
  let corpo;
  // Verifica se tem drawer
  if (drawer) {
    // ALterando a funcao para fechar o drawer
    fnFecharDrawer = () => dispatch(curriculoFecharDrawer());

    const params = drawer?.dados;
    switch (drawer.tipo) {
      case DRAWER.CURRICULO_CRIAR_AGENDAMENTO: // Para intencao de criar um agendamento
        // Funcao de callback para lidar com o agendamento
        const fn = (val) => {
          const { agenda } = val;
          // Pega a data
          const data = format(agenda, "yyyy-MM-dd HH:mm");
          // Pega os outros componentes
          const envio_email_e_whatsapp = val.envio_email_e_whatsapp ? "S" : "N";
          const mensagem_adicional = val.mensagem_adicional
            ? val.mensagem_adicional
            : "";

          // Para criar um novo agendamento
          dispatch(
            curriculoAddUpdCandidatoAgenda(
              {
                id_curriculo: parseInt(params.id),
                agenda: data,
                envio_email_e_whatsapp,
                mensagem_adicional,
              },
              false
            )
          );
        };
        corpo = (
          <Container maxWidth="sm">
            <ComponenteAgendamento fn={fn} nome={params.nome} />
          </Container>
        );
        break;
      case DRAWER.VER_FAVORITOS: // Para ver a aba dos favortios
        corpo = <ListaDeCurriculosFavoritados isMobile={isMobile} />;
        break;
      case DRAWER.VER_FORM_APLICAR_FILTRO: // Para ver o formulario de aplicacao de filtro
        corpo = <FormAplicacaoFiltro fecharDrawer={fnFecharDrawer} />;
        break;
      case DRAWER.VER_AGENDA: // Para ver a agenda no drawer (minha agenda ou agenda dos outros)
        // Sobreescrevendo funcao de fechar o drawer para ele limpar os dados da agenda aberta tambem
        fnFecharDrawer = () => {
          dispatch(curriculoLimparMinhaAgenda());
          dispatch(curriculoFecharDrawer());
        };
        corpo = (
          <ListaDeAgendamentos
            agenda={curriculo?.agenda || {}}
            usuarios={curriculo?.usuarios}
            tipoAgenda={curriculo?.tipoAgenda}
            manterDrawerAntigo={true}
          />
        );
        break;
      case DRAWER.VER_DOWNLOAD_PDF: // Para ver o download em pdf
        corpo = (
          <Container maxWidth="lg">
            <Stack spacing={2} alignItems="center">
              <Typography variant="h6">Download do arquivo em PDF</Typography>
              <Typography variant="caption">
                Clique no botão abaixo para ativar o Download do currículo em
                PDF
              </Typography>
              <BotaoPDF dados={params} />
            </Stack>
          </Container>
        );
        break;
      case DRAWER.DETALHES_CURRICULO:
        let somenteLeitura = false;
        if (curriculo?.tipoAgenda === "outros") {
          somenteLeitura = true;
        } else if (curriculo?.tipoLista === "outros") {
          somenteLeitura = true;
        } else if (!curriculo.tipoLista && !curriculo.tipoAgenda) {
          somenteLeitura = true;
        }

        corpo = (
          <DetalhesCurriculo
            // Se a agenda retornada for dos outrosos botoes de detalhes do curriculo nao
            // devem ser visiveis para interação
            somenteLeitura={somenteLeitura}
            ocultarBotaoRemoverAgenda={curriculo?.tipoAgenda !== "minhaAgenda"}
            favoritos={curriculo?.favoritos}
            detalhes={params}
          />
        );

        break;
      case DRAWER.VER_HISTORICO_CURRICULO: // Para Ver o historico de um curriculo
        corpo = <ListaHistoricoCurriculo historico={params} />;
        break;
      case DRAWER.VER_LISTA_ESPERA: // Para ver a lista de espera
        corpo = (
          <ListaDeEspera
            tipoLista={params.tipoLista}
            listaDeEspera={params.dados}
            usuarios={curriculo?.usuarios}
          />
        );
        break;
      default:
        break;
    }
  } else if (curriculo?.agendaVencida?.length > 0) {
    // Se tiver itens na agenda vencida devemos exibi-los ( o usuario precisa tomar uma decisao)
    corpo = <ListaCurriculosAgendados agenda={curriculo.agendaVencida} />;
  }

  return (
    <Paper xs={{ mt: 1 }} elevation={0}>
      <ToastContainer position="bottom-center" autoClose={1800} limit={1} />
      {corpo ? (
        isMobile ? (
          <Drawer corpo={corpo} fecharDrawer={fnFecharDrawer} />
        ) : (
          <Dialog
            fecharDialogo={fnFecharDrawer}
            corpo={corpo}
            larguraMaxima={Boolean(drawer?.tipo === DRAWER.VER_AGENDA)}
            fullTela={Boolean(
              drawer?.tipo === DRAWER.VER_FAVORITOS ||
                drawer?.tipo === DRAWER.DETALHES_CURRICULO
            )}
            comoSlide={true}
          />
        )
      ) : null}
      <Container disableGutters={isMobile} maxWidth="lg">
        <PainelSuperior
          isMobile={isMobile}
          qtdFavoritos={curriculo?.favoritos?.length}
          //setVerTipo={setExibirDrawer}
        />
        <Divider sx={{ my: 1 }} />
        {curriculo?.corpo || curriculo?.filtro ? (
          curriculo?.filtro ? (
            <ListaDeCurriculosGeralFiltro />
          ) : (
            <ListaDeCurriculosGeral />
          )
        ) : null}
      </Container>
    </Paper>
  );
};
// Componente que se aplica o filtro
const FormAplicacaoFiltro = ({ fecharDrawer }) => {
  // Pegar a resolucao da tela para saber em qual estamos trabalhando
  const {
    breakpoints: { values },
  } = useTheme();
  const isMobile = values["sm"] > window.innerWidth;

  const [filtroEscolhido, setFiltroEscolhido] = useState([]);
  // Criar callback para registrar os campos selecionados
  const callbackSelecao = (valor) =>
    setFiltroEscolhido((state) => {
      const copia = state.slice();
      if (copia.includes(valor)) {
        const index = copia.indexOf(valor);
        copia.splice(index, 1);
      } else {
        copia.push(valor);
      }
      return copia;
    });
  // Lista de botoes para filtros que serão escolhidos
  const filtrosDisponiveis = [
    {
      cor: filtroEscolhido.includes("cpf") ? "primary" : "default",
      texto: "CPF",
      onClick: () => {
        callbackSelecao("cpf");
      },
      icone: <VpnKeyIcon />,
      titulo: "Clique aqui para selecionar o filtro de cpf",
    },
    {
      cor: filtroEscolhido.includes("nome") ? "primary" : "default",
      texto: "Nome",
      onClick: () => {
        callbackSelecao("nome");
      },
      icone: <PersonIcon />,
      titulo: "Clique aqui para selecionar o filtro de nome",
    },
    {
      cor: filtroEscolhido.includes("disponibilidade") ? "primary" : "default",
      texto: "Disponibilidade",
      onClick: () => {
        callbackSelecao("disponibilidade");
      },
      icone: <PlaceIcon />,
      titulo: "Clique aqui para selecionar o filtro de disponibilidade de loja",
    },
    {
      cor: filtroEscolhido.includes("escolaridade") ? "primary" : "default",
      texto: "Escolaridade",
      onClick: () => {
        callbackSelecao("escolaridade");
      },
      icone: <SchoolIcon />,
      titulo: "Clique aqui para selecionar o filtro de escolaridade",
    },
    {
      cor: filtroEscolhido.includes("sexo") ? "primary" : "default",
      texto: "Sexo",
      onClick: () => {
        callbackSelecao("sexo");
      },
      icone: <WcIcon />,
      titulo: "Clique aqui para selecionar o filtro de sexo",
    },
    {
      cor: filtroEscolhido.includes("idade") ? "primary" : "default",
      texto: "Idade",
      onClick: () => {
        callbackSelecao("idade");
      },
      icone: <CakeIcon />,
      titulo: "Clique aqui para selecionar o filtro de idade",
    },
    {
      cor: filtroEscolhido.includes("filho") ? "primary" : "default",
      texto: "Filho",
      onClick: () => {
        callbackSelecao("filho");
      },
      icone: <ChildFriendlyIcon />,
      titulo: "Clique aqui para selecionar o filtro de filhos",
    },
    {
      cor: filtroEscolhido.includes("estado_civil") ? "primary" : "default",
      texto: "Estado Civil",
      onClick: () => {
        callbackSelecao("estado_civil");
      },
      icone: <PersonIcon />,
      titulo: "Clique aqui para selecionar o filtro de estado civil",
    },
    {
      cor: filtroEscolhido.includes("experiencia_profissional")
        ? "primary"
        : "default",
      texto: "Exp. profissional",
      onClick: () => {
        callbackSelecao("experiencia_profissional");
      },
      icone: <EngineeringIcon />,
      titulo:
        "Clique aqui para selecionar o filtro de experiência profissional",
    },
    {
      cor: filtroEscolhido.includes("incluso_desde") ? "primary" : "default",
      texto: "Novos",
      onClick: () => {
        callbackSelecao("incluso_desde");
      },
      icone: <EventAvailableIcon />,
      titulo: "Clique aqui para selecionar o filtro de curriculos novos",
    },
    {
      cor: filtroEscolhido.includes("cargo") ? "primary" : "default",
      texto: "Vaga de interesse",
      onClick: () => {
        callbackSelecao("cargo");
      },
      icone: <WorkIcon />,
      titulo:
        "Clique aqui para selecionar o filtro de vagas de interesse do candidato",
    },
  ];

  return (
    <Container disableGutters sx={{ minHeight: "50vh" }} maxWidth="lg">
      <Stack sx={{ py: 1 }}>
        <Typography variant="h6" align="center">
          Sistema de filtros avançado
        </Typography>
        <Typography variant="caption" align="center">
          Escolha os campos que você deseja usar no filtro, pode combina-los
          para tornar o filtro mais eficiente.
        </Typography>
        <Divider sx={{ my: 1 }} />
        <Paper sx={{ p: 1, zIndex: 10, position: "sticky", top: 0 }}>
          <Stack
            direction="row"
            sx={{ pb: 1.5, overflowX: "auto" }}
            flexWrap="nowrap"
          >
            {filtrosDisponiveis.map((ele, idx) => (
              <Chip
                key={idx}
                sx={{ mx: 0.5 }}
                color={ele.cor}
                label={ele.texto}
                size={isMobile ? "medium" : "small"}
                icon={ele.icone}
                onClick={ele.onClick}
                title={ele.titulo}
              />
            ))}
          </Stack>
        </Paper>
        {filtroEscolhido.length > 0 && (
          <FormFiltroAvancado
            fecharDrawer={fecharDrawer}
            camposSelecionados={filtroEscolhido}
          />
        )}
      </Stack>
    </Container>
  );
};
// Componente para exibir os campos que serão utilizados no filtro
const FormFiltroAvancado = ({ camposSelecionados, fecharDrawer }) => {
  // Formulario com os campos
  const { watch, control, handleSubmit } = useForm();
  //
  const dispatch = useDispatch();
  const curriculo = useSelector((state) => state.curriculo);
  const aguardar = useSelector((state) => state.aguardar);
  // Pegar a resolucao da tela para saber em qual estamos trabalhando
  const {
    breakpoints: { values },
  } = useTheme();
  const isMobile = values["sm"] > window.innerWidth;
  //
  const fn = (val) => {
    const listaValores = {};
    Object.keys(val).forEach((key) => {
      // Veja qual que é esta chave
      if (key.search("disponibilidade") !== -1) {
        // Veja se ela é true, se for pega os campos escolhidos
        if (val[key]) {
          // Se nao tiver disponibilidade envolvida crie um array vazio
          if (!listaValores.disponibilidade) listaValores.disponibilidade = [];

          listaValores.disponibilidade.push(parseInt(key.split("_")[1]));
        }
      }
      // Para os campos Switch de filho e experiencia_profissional
      if (["filho", "experiencia_profissional"].includes(key)) {
        listaValores[key] = val[key] ? "S" : "N";
      }
      // Se tiver o sexo entao adicionar
      if (key === "sexo" && val[key]?.value) {
        listaValores[key] = val[key].value;
      }
      // Estes campos abaixo são todos arrays de valores. Caso existam precisamos fazer loop sobre estes dados.
      if (["estado_civil", "escolaridade"].includes(key)) {
        if (val[key]?.length > 0) {
          listaValores[key] = val[key].map((ele) => ele.value);
        }
      }
      // Se for idades o array e diferente
      if (["idade"].includes(key)) {
        if (val[key]?.length > 0) {
          listaValores[key] = val[key].map((ele) => ele);
        }
      }
      // Se o campo for incluso_desde, este e uma data
      if (key === "incluso_desde") {
        listaValores[key] = val[key];
      }
      // Se o campo de busca for cpf
      if (key === "cpf" && val[key]?.length > 0) {
        listaValores[key] = val[key].replace(/\./g, "").replace("-", "");
      }
      // Se o campo de busca for o nome
      if (key === "nome" && val[key]?.length > 0) {
        listaValores[key] = val[key];
      }
      // Veja se a chave é o cargo
      if (key.search("cargo") !== -1) {
        // Veja se ela é true, se for pega os campos escolhidos
        if (val[key]) {
          // Se nao tiver cargo envolvido crie um array vazio
          if (!listaValores.cargo) listaValores.cargo = [];

          listaValores.cargo.push(parseInt(key.split("_")[1]));
        }
      }
    });
    // Passa agora sobre as chaves e concatena os valores que forem array
    Object.keys(listaValores).forEach((key) => {
      if (Array.isArray(listaValores[key])) {
        listaValores[key] = listaValores[key].join(",");
      }
    });
    // Envia os dados para solicitacao do filtro
    dispatch(curriculoFiltroAvancadoAplicar(listaValores, fecharDrawer));
  };

  const formCampos = {};

  camposSelecionados.forEach((ele, idx) => {
    // Cria uma lista vazia dentro do objeto
    if (!formCampos[ele]) formCampos[ele] = [];
    if (ele === "cargo") {
      // Passa sobre cada cargo e retorna um checkbox nomeado
      curriculo.cargo.forEach((dispo, idx2) => {
        const chaveCampo = `cargo_${dispo[0]}`;

        formCampos[ele].push(
          <motion.div
            key={chaveCampo}
            initial={{ opacity: 0.01 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0.01 }}
            transition={{ duration: 0.3 }}
            style={{ flexBasis: isMobile ? "100%" : "33.3%" }}
          >
            <Controller
              control={control}
              name={chaveCampo}
              render={({ field }) => (
                <FormControlLabel
                  {...field}
                  disabled={aguardar}
                  control={<Checkbox value={dispo[0]} />}
                  label={`${dispo[1]}`}
                />
              )}
            />
          </motion.div>
        );
      });
    } else if (ele === "disponibilidade") {
      // Cria uma lista vazia dentro do objeto
      if (!formCampos[ele]) formCampos[ele] = [];
      // Passa sobre cada disponibilidade e retorna um checkbox nomeado
      Object.keys(curriculo.disponibilidade).forEach((key, idx1) => {
        // Separa as regioes colocando o titulo da cidade
        formCampos[ele].push(
          <Stack key={key} sx={{ mt: 1, flexBasis: "100%" }}>
            <Divider />
            <Typography fontWeight="bold" variant="h5" align="left">
              {key}
            </Typography>
          </Stack>
        );

        curriculo.disponibilidade[key].forEach((dispo, idx2) => {
          const chaveCampo = `disponibilidade_${dispo[0]}`;

          formCampos[ele].push(
            <motion.div
              key={chaveCampo}
              initial={{ opacity: 0.01 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0.01 }}
              transition={{ duration: 0.3 }}
              style={{ flexBasis: isMobile ? "100%" : "33.3%" }}
            >
              <Controller
                control={control}
                name={chaveCampo}
                render={({ field }) => (
                  <FormControlLabel
                    {...field}
                    disabled={aguardar}
                    control={<Checkbox value={dispo[0]} />}
                    label={`${dispo[1]}`}
                  />
                )}
              />
            </motion.div>
          );
        });
      });
    } else if (ele === "escolaridade") {
      const chaveCampo = ele;
      formCampos[ele] = (
        <motion.div
          key={chaveCampo}
          initial={{ opacity: 0.01 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0.01 }}
          transition={{ duration: 0.3 }}
          style={{ flexBasis: "100%" }}
        >
          <Controller
            control={control}
            name={chaveCampo}
            defaultValue={null}
            render={({ field }) => (
              <Select
                options={formatarParaSelect(curriculo.escolaridade)}
                {...field}
                styles={selectStyles}
                isMulti
                components={animetedComponents}
                placeholder="Escolha o grau de escolaridade"
              />
            )}
          />
        </motion.div>
      );
    } else if (ele === "sexo") {
      const chaveCampo = ele;
      formCampos[ele] = (
        <motion.div
          key={chaveCampo}
          initial={{ opacity: 0.01 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0.01 }}
          transition={{ duration: 0.3 }}
          style={{ flexBasis: "100%" }}
        >
          <Controller
            control={control}
            name={chaveCampo}
            defaultValue={null}
            render={({ field }) => (
              <Select
                options={formatarParaSelect([
                  ["M", "Masculino"],
                  ["F", "Feminino"],
                ])}
                {...field}
                styles={selectStyles}
                components={animetedComponents}
                placeholder="Escolha o sexo do candidato"
              />
            )}
          />
        </motion.div>
      );
    } else if (ele === "idade") {
      const chaveCampo = ele;
      formCampos[ele] = (
        <motion.div
          key={chaveCampo}
          initial={{ opacity: 0.01 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0.01 }}
          transition={{ duration: 0.3 }}
          style={{ flexBasis: "100%" }}
        >
          <Controller
            control={control}
            name={chaveCampo}
            defaultValue={curriculo.idades}
            render={({ field }) => (
              <Container maxWidth="sm">
                <Slider
                  //valueLabelFormat={val=> `${val} anos`}
                  min={curriculo.idades[0]}
                  max={curriculo.idades[1] + 1}
                  getAriaLabel={() => "Idades"}
                  {...field}
                  aria-label="Always visible"
                  valueLabelDisplay="on"
                />
              </Container>
              // <Select options={formatarParaSelect(curriculo.idades)}
              //     {...field} isMulti styles={selectStyles}
              //     components={animetedComponents}
              //     placeholder='Escolha as idades dos candidatos'
              // />
            )}
          />
        </motion.div>
      );
    } else if (ele === "filho") {
      const chaveCampo = ele;

      formCampos[ele] = (
        <motion.div
          key={chaveCampo}
          initial={{ opacity: 0.01 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0.01 }}
          transition={{ duration: 0.3 }}
          style={{ flexBasis: "100%" }}
        >
          <Controller
            control={control}
            name={chaveCampo}
            render={({ field }) => (
              <FormControlLabel
                {...field}
                disabled={aguardar}
                control={<Switch />}
                label="Possui filho(s)"
              />
            )}
          />
        </motion.div>
      );
    } else if (ele === "estado_civil") {
      const chaveCampo = ele;
      formCampos[ele] = (
        <motion.div
          key={chaveCampo}
          initial={{ opacity: 0.01 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0.01 }}
          transition={{ duration: 0.3 }}
          style={{ flexBasis: "100%" }}
        >
          <Controller
            control={control}
            name={chaveCampo}
            defaultValue={null}
            render={({ field }) => (
              <Select
                options={formatarParaSelect(curriculo.estado_civil)}
                {...field}
                styles={selectStyles}
                isMulti
                components={animetedComponents}
                placeholder="Escolha o estado civil do candidato"
              />
            )}
          />
        </motion.div>
      );
    } else if (ele === "experiencia_profissional") {
      const chaveCampo = ele;

      formCampos[ele] = (
        <motion.div
          key={chaveCampo}
          initial={{ opacity: 0.01 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0.01 }}
          transition={{ duration: 0.3 }}
          style={{ flexBasis: "100%" }}
        >
          <Controller
            control={control}
            name={chaveCampo}
            render={({ field }) => (
              <FormControlLabel
                {...field}
                disabled={aguardar}
                control={<Switch />}
                label="Experiência profissional"
              />
            )}
          />
        </motion.div>
      );
    } else if (ele === "incluso_desde") {
      const chaveCampo = ele;
      formCampos[ele] = (
        <motion.div
          key={chaveCampo}
          initial={{ opacity: 0.01 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0.01 }}
          transition={{ duration: 0.3 }}
          style={{ flexBasis: "100%" }}
        >
          <Controller
            name={chaveCampo}
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <TextField
                {...field}
                type="date"
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                defaultValue={format(new Date(), "yyyy-MM-dd")}
                inputProps={{ max: format(new Date(), "yyyy-MM-dd") }}
              />
            )}
          />
        </motion.div>
      );
    } else if (ele === "cpf") {
      const chaveCampo = ele;
      formCampos[ele] = (
        <motion.div
          key={chaveCampo}
          initial={{ opacity: 0.01 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0.01 }}
          transition={{ duration: 0.3 }}
          style={{ flexBasis: "100%" }}
        >
          <Controller
            name={chaveCampo}
            control={control}
            render={({ field }) => (
              <MaskedInput
                {...field}
                mask={[
                  /\d/,
                  /\d/,
                  /\d/,
                  ".",
                  /\d/,
                  /\d/,
                  /\d/,
                  ".",
                  /\d/,
                  /\d/,
                  /\d/,
                  "-",
                  /\d/,
                  /\d/,
                ]}
                // onBlur={ele.onBlur} onKeyUp={ele.onKeyUp}
                render={(ref, props) => (
                  <TextField
                    inputRef={ref}
                    {...props}
                    type="text"
                    fullWidth
                    size="small"
                    label="CPF"
                    placeholder="000.000.000-00"
                    InputLabelProps={{ shrink: true }}
                  />
                )}
              />
            )}
          />
        </motion.div>
      );
    } else if (ele === "nome") {
      const chaveCampo = ele;
      formCampos[ele] = (
        <motion.div
          key={chaveCampo}
          initial={{ opacity: 0.01 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0.01 }}
          transition={{ duration: 0.3 }}
          style={{ flexBasis: "100%" }}
        >
          <Controller
            name={chaveCampo}
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                type="text"
                fullWidth
                size="small"
                label="Nome"
                placeholder="Nome do candidato"
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
        </motion.div>
      );
    }
  });

  return (
    <Stack sx={{ mt: 2 }}>
      {Object.keys(formCampos).map((tipoCampo, idx) => {
        return (
          <Stack sx={{ mt: 1 }} key={idx}>
            <Typography
              color="primary"
              variant="subtitle2"
              fontWeight="bold"
              align="center"
            >
              {tipoCampo.toUpperCase().replace("_", " ")}
            </Typography>

            <Stack direction="row" flexWrap="wrap">
              <AnimatePresence>{formCampos[tipoCampo]}</AnimatePresence>
            </Stack>
            {tipoCampo.toUpperCase() === "IDADE" && watch("idade") && (
              <Typography align="center" variant="caption">
                Candidatos entre {watch("idade")[0]} e {watch("idade")[1]} anos
              </Typography>
            )}
            <Divider />
          </Stack>
        );
      })}
      <Stack sx={{ my: 1 }} alignItems="center">
        <Button
          disabled={aguardar}
          variant="contained"
          onClick={handleSubmit(fn)}
          startIcon={
            aguardar ? <CircularProgress size={20} /> : <FilterAltIcon />
          }
        >
          Aplicar Filtro
        </Button>
      </Stack>
      <br />
      <br />
      <br />
    </Stack>
  );
};
// Componente que exibirá a lista de curriculos favoritados
const ListaDeCurriculosFavoritados = ({ isMobile }) => {
  const corpo = useSelector((state) => state.curriculo?.favoritos);

  //
  return (
    <Stack sx={{ py: 1, maxHeight: "85vh" }}>
      <Typography align="center" varian="subtitle1">
        Lista com os meus curriculos favoritados
      </Typography>
      <Container disableGutters={isMobile} maxWidth="lg">
        {corpo?.length < 1 ? (
          <RetornoEmBranco />
        ) : (
          <Stack direction="row" flexWrap="wrap">
            {corpo?.map((ele, idx) => {
              return (
                <ItemDaLista key={ele.id} {...ele} manterDrawerAntigo={true} />
              );
            })}
          </Stack>
        )}
      </Container>
    </Stack>
  );
};
// Componente que representa o painel superior com funções extras da aplicacao
const PainelSuperior = memo(({ qtdFavoritos, setVerTipo, isMobile }) => {
  const dispatch = useDispatch();

  let botoes = [
    {
      icone: <PermContactCalendarIcon />,
      onClick: () => {
        dispatch(curriculoGetAgenda("minhaAgenda"));
        //setVerTipo('agenda');
      },
      textoMobile: "Ag. Minha",
      texto: "Minha Agenda",
      titulo: "Exibe os currículos que agendei",
    },
    {
      icone: <DateRangeIcon />,
      onClick: () => {
        dispatch(curriculoGetAgenda("outros"));
        //setVerTipo('agenda');
      },
      textoMobile: "Ag. Outros",
      texto: "Agenda Geral",
      titulo: "Exibe os currículos agendado pelos outros",
    },
    {
      icone: <AirlineSeatReclineNormalIcon />,
      onClick: () => {
        dispatch(curriculoGetListaDeEspera("minhaLista"));
      },
      textoMobile: "Lis. Minha",
      texto: "Minha Lista",
      titulo: "Exibe os currículos inseridos na lista de espera",
    },
    {
      icone: <GroupsIcon />,
      onClick: () => {
        dispatch(curriculoGetListaDeEspera("outros"));
      },
      textoMobile: "Lis. outros",
      texto: "Lista Geral",
      titulo: "Exibe os currículos inseridos na lista de espera pelos outros",
    },
  ];
  //  Botoes para acoes secundarias
  let botoesSecundarias = [
    {
      icone: (
        <Badge
          color="primary"
          badgeContent={qtdFavoritos > 9 ? "+9" : qtdFavoritos}
        >
          <FavoriteIcon />
        </Badge>
      ),
      onClick: () => {
        //setVerTipo('exibirFavoritos');
        dispatch(curriculoSetDrawer({ tipo: DRAWER.VER_FAVORITOS }));
      },
      textoMobile: "Meus Favoritos",
      texto: "Meus Favoritos",
      titulo: "Exibe os currículos que marquei como favoritos",
    },
    {
      icone: <FilterAltIcon />,
      onClick: () => {
        //dispatch( curriculoGetListaDeEspera('outros') );
        // setVerTipo('exibirFormAplicarFiltro');
        dispatch(curriculoSetDrawer({ tipo: DRAWER.VER_FORM_APLICAR_FILTRO }));
      },
      textoMobile: "Filtros",
      texto: "Filtros",
      titulo:
        "Para fazer filtros sobre a base de currículos definindo o que se deseja",
    },
  ];
  // Se nao for mobile integrar as acoes secundarias
  if (!isMobile) {
    botoes = botoes.concat(botoesSecundarias);
    // Eliminar os botoes secundarios
    botoesSecundarias = null;
  }

  let sxPaper = isMobile ? { mb: 1, p: 0.5 } : { my: 2, p: 0.5 };
  // Travando o painel na parte superior
  sxPaper = { ...sxPaper, position: "sticky", top: "0", zIndex: 24 };

  return (
    <Paper sx={sxPaper} elevation={3}>
      <Stack justifyContent="space-around" direction="row">
        {botoes.map((ele, idx) => (
          <Button
            size="small"
            startIcon={!isMobile && ele.icone}
            key={idx}
            onClick={ele.onClick}
            title={ele.titulo}
          >
            {!isMobile && ele.texto}
            {isMobile && (
              <Stack alignItems="center">
                {ele.icone}
                <Typography variant="caption" align="center">
                  {ele.textoMobile}
                </Typography>
              </Stack>
            )}
          </Button>
        ))}
      </Stack>
      {botoesSecundarias && <Divider />}
      <Stack justifyContent="space-around" direction="row">
        {botoesSecundarias?.map((ele, idx) => (
          <Button
            size={isMobile ? "small" : "normal"}
            startIcon={!isMobile && ele.icone}
            key={idx}
            onClick={ele.onClick}
            title={ele.titulo}
          >
            {!isMobile && ele.texto}
            {isMobile && (
              <Stack alignItems="center">
                {ele.icone}
                <Typography variant="caption" align="center">
                  {ele.textoMobile}
                </Typography>
              </Stack>
            )}
          </Button>
        ))}
      </Stack>
    </Paper>
  );
});
// Componente para fazer a listagem dos curriculos na tela. Mas no caso sao os curriculos do filtro
const ListaDeCurriculosGeralFiltro = () => {
  const dispatch = useDispatch();
  // Controla o estado somente neste componente de lista
  const [pagina, setPagina] = useState(1);
  //
  const curriculos = useSelector((state) => state.curriculo?.filtro);
  // Verifica quantas paginas serão criadas neste filtro
  let quantidade_pagina = 1;
  const TOTAL_POR_PAGINA = 21;
  try {
    const resto = curriculos.length % TOTAL_POR_PAGINA === 0 ? 0 : 1; // Esta sobrando valores nesta divisao
    quantidade_pagina = parseInt(curriculos.length / TOTAL_POR_PAGINA + resto);
  } catch (err) {
    console.log(err);
    quantidade_pagina = 1;
  }
  // Agora vamos extrair o valor atual da pagina.
  const corpo = curriculos
    .slice()
    .splice(TOTAL_POR_PAGINA * (pagina - 1), TOTAL_POR_PAGINA);

  // Funcao de callback para manipular paginacao
  const manipularPaginacao = (evt, value) => {
    setPagina(value);
  };

  return (
    <Stack>
      <Typography variant="h6" align="center">
        Curriculo(s) baseado no filtro
      </Typography>

      <Stack direction={{ xs: "column", md: "row" }}>
        <Pagination
          color="primary"
          value={pagina}
          count={quantidade_pagina}
          onChange={manipularPaginacao}
        />
        <Button
          title="Fechar o filtro Aplicado"
          onClick={() => dispatch(curriculoFiltroAvancadoLimpar())}
          startIcon={<CloseIcon />}
          variant="outlined"
          size="small"
        >
          FECHAR FILTRO
        </Button>
      </Stack>
      {corpo?.length < 1 ? (
        <RetornoEmBranco />
      ) : (
        <Stack direction="row" flexWrap="wrap">
          {corpo?.map((ele, idx) => {
            return <ItemDaLista key={ele.id} {...ele} />;
          })}
        </Stack>
      )}
    </Stack>
  );
};
// Componente para fazer a listagem dos curriculos na tela. Tela inicial
const ListaDeCurriculosGeral = () => {
  const dispatch = useDispatch();
  // Controla o estado somente neste componente de lista
  const [aguardar, setAguardar] = useState(false);
  //const [pagina, setPagina] = useState(1);
  //
  const curriculos = useSelector((state) => state.curriculo?.corpo);
  const quantidade_pagina = useSelector(
    (state) => state.curriculo?.quantidade_pagina
  );
  // Funcao de callback para manipular paginacao
  const manipularPaginacao = async (evt, value) => {
    setAguardar(true);
    await dispatch(curriculoGetCurriculoPorPagina(value));
    //setPagina(value);
    setAguardar(false);
  };
  // Mapeamento
  const corpo = !aguardar ? curriculos : Array.from(Array(21));

  return (
    <Stack>
      <Pagination
        color="primary"
        //value={pagina}
        count={quantidade_pagina}
        onChange={manipularPaginacao}
      />
      <Stack direction="row" flexWrap="wrap">
        {corpo?.map((ele, idx) => {
          return aguardar ? (
            <ItemDaListaSkeleton key={idx} />
          ) : (
            <ItemDaLista key={ele.id} {...ele} />
          );
        })}
      </Stack>
    </Stack>
  );
};
// Cria um Pseudo componente que é na verdade um Skeleton
const ItemDaListaSkeleton = () => (
  <Card sx={{ m: 0.5 }} width={375} height={350}>
    <Typography variant="h4" sx={{ my: 1, px: 1 }}>
      <Skeleton variant="rectangular" width={375 - 16} />
    </Typography>
    <Divider />
    <Typography variant="body1" sx={{ my: 1, px: 1 }}>
      <Skeleton variant="rectangular" />
    </Typography>
    <Typography variant="body2" sx={{ my: 1, px: 1 }}>
      <Skeleton variant="rectangular" />
    </Typography>
    <Typography variant="body1" sx={{ my: 1, px: 1 }}>
      <Skeleton variant="rectangular" />
    </Typography>
    <Typography variant="body1" sx={{ my: 1, px: 1 }}>
      <Skeleton variant="rectangular" />
    </Typography>
    <Stack direction="row" justifyContent="space-between">
      <Button sx={{ flex: 1 }}>
        <Skeleton type="rectangular" height={48} width="100%" />
      </Button>
      <Button sx={{ flex: 1 }}>
        <Skeleton type="rectangular" height={48} width="100%" />
      </Button>
      <Button sx={{ flex: 1 }}>
        <Skeleton type="rectangular" height={48} width="100%" />
      </Button>
      <Button sx={{ flex: 1 }}>
        <Skeleton type="rectangular" height={48} width="100%" />
      </Button>
    </Stack>
  </Card>
);
// Cria o componente que gerencia os botoes da interface do card
const ItemDaListaBotoes = memo(({ manterDrawerAntigo, id, nomeCandidato }) => {
  const dispatch = useDispatch();
  // Cria os callbacks
  const callbackAgenda = (idCur) =>
    dispatch(
      curriculoSetDrawer(
        {
          tipo: DRAWER.CURRICULO_CRIAR_AGENDAMENTO,
          dados: { id: idCur, nome: nomeCandidato },
        },
        manterDrawerAntigo
      )
    );

  // const callbackAgenda = useCallback(
  //     (idCur)=>{ fnCriarAgendamento(idCur); }, [fnCriarAgendamento]
  // );
  const callbackDetalhes = useCallback(
    (idCur, drawerAntigo) => {
      dispatch(curriculoGetDetalhesCurriculo(idCur, null, drawerAntigo));
    },
    [dispatch]
  );
  const callbackHistorico = useCallback(
    (idCur, drawerAntigo) => {
      dispatch(curriculoGetHistorico(idCur, drawerAntigo));
    },
    [dispatch]
  );
  const callbackPDF = async (idCur) => {
    try {
      const resp = await axios.get(`/detalhes_curriculo/${idCur}`);

      // Tudo certo vamos retornar os dados de retorno do PDF
      dispatch(
        curriculoSetDrawer(
          { tipo: DRAWER.VER_DOWNLOAD_PDF, dados: resp.data },
          manterDrawerAntigo
        )
      );
    } catch (err) {
      if (err?.response?.data?.message) {
        ToastErro(err.response.data.message);
      } else {
        ToastErro(String(err));
      }
    }
  };

  // Automatizar a criacao dos botoes
  const botoes = [
    {
      texto: "Agenda",
      titulo: "Clique aqui para agendar este candidato",
      onClick: callbackAgenda,
      icone: <EventIcon />,
      variant: "contained",
    },
    {
      texto: "VER",
      titulo: "Clique aqui para ver todos os detalhes deste candidato",
      onClick: callbackDetalhes,
      icone: <ContactPageIcon />,
      variant: "contained",
    },
    {
      texto: "HIST",
      titulo: "Clique aqui para ver o histórico deste candidato.",
      onClick: callbackHistorico,
      icone: <HistoryIcon />,
      variant: "contained",
    },
    {
      texto: "PDF",
      titulo: "Clique aqui para baixar uma versão completa do currículo em PDF",
      onClick: callbackPDF,
      icone: <FileDownloadIcon />,
      variant: "contained",
    },
  ];

  return (
    <CardActions sx={{ justifyContent: "space-between" }}>
      {botoes.map((ele, idx) => (
        <Button
          key={idx}
          size="small"
          variant={ele.variant}
          title={ele.titulo}
          startIcon={ele.icone}
          onClick={() => ele.onClick(id, manterDrawerAntigo)}
        >
          {ele.texto}
        </Button>
      ))}
    </CardActions>
  );
});
// Cria o componente item da lista
const ItemDaLista = memo(
  ({
    manterDrawerAntigo,
    id,
    idade,
    recadastro,
    celular,
    escolaridade,
    nome,
    sexo,
    data_inclusao,
  }) => {
    const favoritos = useSelector((state) => state.curriculo?.favoritos);
    const isFav = favoritos?.some((eleIn) => String(eleIn.id) === String(id));

    return (
      <Card
        elevation={3}
        sx={{
          display: "flex",
          flexDirection: "column",
          py: 0.5,
          m: 0.5,
          width: 375,
          height: 350,
          overflowY: "auto",
        }}
      >
        <CardContent sx={{ flex: 1 }}>
          <Stack
            alignItems="center"
            sx={{ py: 0.5 }}
            direction="row"
            justifyContent="space-between"
          >
            <Stack alignItems="flex-start" justifyContent="flex-start">
              <Typography title={nome} fontWeight="bold" variant="subtitle1">
                {nome}
              </Typography>
              {recadastro && (
                <Chip
                  icon={<PriorityHighIcon />}
                  label="Recadastro"
                  color="primary"
                  size="small"
                  title="Este curriculo chegou por meio de recadastro"
                />
              )}
            </Stack>
            <FavoritoIcone id={id} favoritado={isFav} />
          </Stack>
          <Divider sx={{ mt: 0.5, mb: 1 }} />
          <Stack sx={{ mb: 1 }} direction="row" alignItems="flex-end">
            <CakeIcon color="primary" /> &nbsp;
            <Typography variant="body2">{idade} anos</Typography>
          </Stack>
          <Stack sx={{ mb: 1 }} direction="row" alignItems="flex-end">
            <SchoolIcon color="primary" /> &nbsp;
            <Typography variant="body2">{escolaridade}</Typography>
          </Stack>
          <Stack sx={{ mb: 1 }} direction="row" alignItems="flex-end">
            {sexo?.toLowerCase() === "feminino" ? (
              <FemaleIcon color="primary" />
            ) : (
              <MaleIcon color="primary" />
            )}{" "}
            &nbsp;
            <Typography variant="body2">{sexo}</Typography>
          </Stack>
          <Stack sx={{ mb: 1 }} direction="row" alignItems="flex-end">
            <BotaoContato celular={celular} />
          </Stack>
          <Stack sx={{ mb: 1 }} direction="row" alignItems="flex-end">
            <EventAvailableIcon color="primary" />
            <Typography sx={{ mx: 1 }} variant="body2">
              Data de inclusão:{" "}
            </Typography>
            <Typography variant="body2">
              {format(parseISO(data_inclusao), "dd/MM/yy HH:mm")}
            </Typography>
          </Stack>
          <Divider />
        </CardContent>
        <ItemDaListaBotoes
          id={id}
          nomeCandidato={nome}
          manterDrawerAntigo={manterDrawerAntigo}
        />
      </Card>
    );
  }
);
// Componente para exibir o favorito ou nao
const FavoritoIcone = ({ id, favoritado }) => {
  const [isFav, setIsFav] = useState(favoritado);
  const dispatch = useDispatch();

  const callbackFav = useCallback(() => {
    // Funcao par ativar/desativar um currículo dos favoritos
    dispatch(curriculoAddDelFavorito({ id_curriculo: id }, isFav));
    setIsFav((state) => !state);
  }, [dispatch, isFav, id]);

  return (
    <IconButton
      title="Marque/Desmarque este currículo como favorito."
      onClick={callbackFav}
    >
      {isFav ? (
        <FavoriteIcon color="error" />
      ) : (
        <FavoriteBorderIcon color="error" />
      )}
    </IconButton>
  );
};
// Componente para exibir a lista de curriculos agendados
const ListaCurriculosAgendados = ({ agenda }) => {
  // Usar um estado para ativar o campo textarea para inserção da observacao
  const [formOBS, setFormOBS] = useState(null);
  // Pegar a resolucao da tela para saber em qual estamos trabalhando
  const {
    breakpoints: { values },
  } = useTheme();
  const isMobile = values["sm"] > window.innerWidth;

  const botoes = [
    {
      icone: <ThumbUpAltIcon />,
      onClick: (ID_CUR) => {
        // Ativa/desativa a exibicao do form
        if (formOBS === `${ID_CUR}_A`) {
          setFormOBS(null);
        } else {
          setFormOBS(`${ID_CUR}_A`);
        }
        // Envia este candidato para aprovado e solicita atualizacao da agendaVencida
      },
      texto: isMobile ? "APR" : "APROVAR",
      titulo: "Marcar o currículo como aprovado",
    },
    {
      icone: <ThumbDownOffAltIcon />,
      onClick: (ID_CUR) => {
        // Ativa/desativa a exibicao do form
        if (formOBS === `${ID_CUR}_R`) {
          setFormOBS(null);
        } else {
          setFormOBS(`${ID_CUR}_R`);
        }
      },
      texto: isMobile ? "REP" : "REPROVAR",
      titulo: "Marcar o currículo como reprovado",
    },
    {
      icone: <AirlineSeatReclineNormalIcon />,
      onClick: (ID_CUR) => {
        // Ativa/desativa a exibicao do form
        if (formOBS === `${ID_CUR}_L`) {
          setFormOBS(null);
        } else {
          setFormOBS(`${ID_CUR}_L`);
        }
      },
      texto: isMobile ? "ESP" : "ESPERA",
      titulo: "Mover o currículo para a lista de espera",
    },
    {
      icone: <EventBusyIcon />,
      onClick: (ID_AGENDA) => {
        // Ativa/desativa a exibicao das outras opcoes
        if (formOBS === `AGENDA_${ID_AGENDA}`) {
          setFormOBS(null);
        } else {
          setFormOBS(`AGENDA_${ID_AGENDA}`);
        }
      },
      texto: isMobile ? "AGE" : "AGENDA",
      titulo: "Retirar o curriculo dos agendamentos",
    },
  ];
  // Funcao para controlar a cor do botão ativo
  function fnFormatarCorBotao(formOBS, ID, idx2) {
    let tipoBotao = "outlined";
    if (!formOBS) return tipoBotao;
    //
    if (formOBS === `${ID.toString()}_A` && idx2 === 0) {
      tipoBotao = "contained";
    } else if (formOBS === `${ID.toString()}_R` && idx2 === 1) {
      tipoBotao = "contained";
    } else if (formOBS === `${ID.toString()}_L` && idx2 === 2) {
      tipoBotao = "contained";
    } else if (formOBS === `AGENDA_${ID.toString()}` && idx2 === 3) {
      tipoBotao = "contained";
    }
    return tipoBotao;
  }

  return (
    <Container sx={{ p: 1, maxHeight: "80vh" }} maxWidth="lg">
      <Stack>
        <Typography variant="h6" align="center">
          Listagem dos currículos agendados
        </Typography>
        <Typography sx={{ opacity: 0.5 }} variant="body2" align="center">
          Estes currículos que se encontram em sua agenda expiraram. O que fazer
          com eles ?
        </Typography>
        <Divider />
        <List>
          {agenda.map((ele) => {
            const {
              id_curriculo,
              nome,
              celular,
              idade,
              id_agenda,
              data_agendamento,
            } = ele;
            return (
              <Stack key={id_curriculo}>
                <ListItem divider>
                  <Stack sx={{ width: "100%" }}>
                    <ListItemText
                      primary={
                        <Stack direction="row" alignItems="center">
                          <Avatar sx={{ background: "#b71c1c" }}>
                            {nome.substring(0, 1)}
                          </Avatar>
                          <Typography sx={{ ml: 1 }} textOverflow="ellipsis">
                            {nome}
                          </Typography>
                        </Stack>
                      }
                      secondary={
                        <Stack>
                          <Stack
                            sx={{ my: 1 }}
                            alignItems="center"
                            direction="row"
                          >
                            <BotaoContato celular={celular} />
                            <CakeIcon />
                            <Typography variant="body2">
                              {idade} Anos
                            </Typography>
                          </Stack>
                          <Stack
                            title="Data de agendamento da entrevista"
                            alignItems="center"
                            direction="row"
                          >
                            <EventAvailableIcon />
                            <Typography sx={{ mx: 1 }} variant="caption">
                              Agendado:{" "}
                            </Typography>
                            <Typography variant="caption">
                              {format(
                                parseISO(data_agendamento),
                                "dd/MM/yy HH:mm"
                              )}
                            </Typography>
                          </Stack>
                        </Stack>
                      }
                    />
                    <Stack
                      sx={{ my: 1 }}
                      direction="row"
                      justifyContent="space-around"
                    >
                      {botoes.map((btn, idx2) =>
                        isMobile ? (
                          <Stack alignItems="center" key={idx2}>
                            <IconButton
                              color="primary"
                              title={btn.titulo}
                              onClick={() => btn.onClick(id_curriculo)}
                            >
                              {btn.icone}
                            </IconButton>
                            <Typography variant="caption">
                              {btn.texto}
                            </Typography>
                          </Stack>
                        ) : (
                          <Button
                            variant={fnFormatarCorBotao(
                              formOBS,
                              idx2 === 3 ? id_agenda : id_curriculo,
                              idx2
                            )}
                            key={idx2}
                            sx={{ mx: 1 }}
                            onClick={() =>
                              btn.onClick(idx2 === 3 ? id_agenda : id_curriculo)
                            }
                            title={btn.titulo}
                            startIcon={btn.icone}
                            size="small"
                          >
                            {btn.texto}
                          </Button>
                        )
                      )}
                    </Stack>
                    <AnimatePresence>
                      {formOBS && formOBS.search("AGENDA") !== -1 ? (
                        <ConfirmAgendamento
                          fnFecharObs={() => setFormOBS(null)}
                          id_agenda={id_agenda}
                        />
                      ) : formOBS &&
                        formOBS.search(id_curriculo.toString()) !== -1 ? (
                        <FormJustificarUsoCurriculo
                          key="form_justi"
                          id_curriculo={id_curriculo}
                          status={formOBS.split("_")[1]}
                          fnFecharObs={() => setFormOBS(null)}
                        />
                      ) : null}
                    </AnimatePresence>
                  </Stack>
                </ListItem>
              </Stack>
            );
          })}
        </List>
      </Stack>
    </Container>
  );
};
// Este componente exibe o formulario que o usuario deve preencher para justificar o motivo
const FormJustificarUsoCurriculo = ({ fnFecharObs, id_curriculo, status }) => {
  const { aguardar } = useSelector((state) => state);
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  // Funcao para pegar o valor da observacao
  const fn = (val) => {
    const { observacao } = val;
    // Agora envia para confirmar para onde o curriculo será enviado
    dispatch(
      curriculoAprovarReprovarReservarCandidato(
        {
          id_curriculo,
          status,
          observacao,
        },
        fnFecharObs
      )
    );
  };
  return (
    <motion.div
      initial={{ opacity: 0.01, height: 0.01 }}
      animate={{ height: "auto", opacity: 1 }}
      exit={{ opacity: 0.01, height: 0.01 }}
      transition={{ duration: 0.3 }}
    >
      <Stack>
        <Divider />
        <Typography sx={{ my: 2 }} variant="subtitle1" align="center">
          Descreva o motivo de enviar este curriculo para
          <Typography color="primary">{fnGetTexto(status)}.</Typography>
        </Typography>
        <Controller
          control={control}
          name="observacao"
          rules={{ required: true }}
          render={({ field }) => (
            <TextField
              fullWidth
              {...field}
              type="textarea"
              multiline
              minRows={2}
              autoFocus
              label="Observação"
              size="small"
              helperText={!!errors.observacao && "* Campo obrigatório"}
              error={!!errors.observacao}
              placeholder="Digite aqui a sua justificativa..."
            />
          )}
        />

        <Stack sx={{ my: 2 }} direction="row-reverse">
          <Button
            onClick={handleSubmit(fn)}
            variant="contained"
            disabled={aguardar}
            size="small"
            startIcon={aguardar ? <CircularProgress size={20} /> : <SaveIcon />}
          >
            ENVIAR
          </Button>
          <Button size="small" sx={{ mx: 1 }} onClick={fnFecharObs}>
            Cancelar
          </Button>
        </Stack>
      </Stack>
    </motion.div>
  );
};
// Este componente exibe opcoes para o usuario confirmar ou nao se deseja excluir aquele agendamento
const ConfirmAgendamento = ({ fnFecharObs, id_agenda }) => {
  const dispatch = useDispatch();
  const { aguardar } = useSelector((state) => state);

  return (
    <motion.div
      initial={{ height: 0.01, opacity: 0.01 }}
      animate={{ height: "auto", opacity: 1 }}
      exit={{ height: 0.01, opacity: 0.01 }}
      transition={{ duration: 0.2 }}
    >
      <Stack sx={{ mt: 1 }}>
        <Typography variant="subtitle1" align="center">
          Deseja remover o currículo da agenda ?
        </Typography>
        <Typography sx={{ opacity: 0.7 }} variant="caption" align="center">
          Caso confirme esta ação não poderá ser desfeita. Será necessário
          incluir o currículo novamente na sua agenda.
        </Typography>
        <Stack direction="row-reverse">
          <Button
            variant="contained"
            sx={{ mx: 0.5 }}
            startIcon={aguardar && <CircularProgress size={20} />}
            disabled={aguardar}
            onClick={() => {
              fnFecharObs();
              dispatch(
                curriculoRemoverCandidatoAgendaVencida(
                  { id_agenda },
                  fnFecharObs
                )
              );
            }}
          >
            SIM
          </Button>
          <Button
            disabled={aguardar}
            sx={{ mx: 0.5 }}
            startIcon={aguardar && <CircularProgress size={20} />}
            onClick={fnFecharObs}
          >
            NÃO
          </Button>
        </Stack>
      </Stack>
    </motion.div>
  );
};
//
// Renderiza uma visualizacao para listar os agendamentos
const ListaDeAgendamentos = ({
  manterDrawerAntigo,
  usuarios,
  agenda,
  tipoAgenda,
}) => {
  const dispatch = useDispatch();
  // Recuperar o tema e pegar a cor verde para aplicar aos titulos no darkMode
  const {
    breakpoints: { values },
  } = useTheme();

  // Vendo se e mobile ou nao
  const isMobile = values["sm"] > window.innerWidth;
  // Estado para controlar o selecionado
  const [selecionado, setSelecionado] = useState(0);
  // Estado para determinar que um agendamento será alterado
  const [alterarAgenda, setAlterarAgenda] = useState(null);

  // Botoes de texto
  const arr = [
    { texto: `Próx. 7 dias`, onClick: () => setSelecionado(0) },
    { texto: `Do 8° ao 15° dia`, onClick: () => setSelecionado(1) },
    { texto: `Após 15° dia`, onClick: () => setSelecionado(2) },
  ];
  // Opcoes de filtro
  const opcoesDias = {
    0: { start: subDays(new Date(), 1), end: addDays(new Date(), 7) },
    1: { start: addDays(new Date(), 7), end: addDays(new Date(), 15) },
    2: { start: addDays(new Date(), 15), end: new Date(2040, 1, 1) },
  };
  // Baseado no botao selecionado busca os dias
  const diasSelecionados = Object.keys(agenda).filter((key) =>
    isWithinInterval(parseISO(key), opcoesDias[selecionado])
  );
  diasSelecionados.sort();

  // Funcao para exibir detalhes
  const fnDetalhes = (idCur, idAgd) => {
    dispatch(curriculoGetDetalhesCurriculo(idCur, idAgd, manterDrawerAntigo));
  };
  // Funcao para remover um curriculo dos agendados
  const fnRemoverAgendamento = (idAgenda) => {
    dispatch(curriculoRemoverCandidatoAgenda({ id_agenda: idAgenda }));
  };
  // Funcao para despachar os dados para atualizacao
  const fnAtualizaAgendamento = (idAgenda) => {
    return (val) => {
      const { agenda } = val;
      // Pega a data
      const data = format(agenda, "yyyy-MM-dd HH:mm");
      // Pega os outros componentes
      const envio_email_e_whatsapp = val.envio_email_e_whatsapp ? "S" : "N";
      const mensagem_adicional = val.mensagem_adicional
        ? val.mensagem_adicional
        : "";
      // Envia os dados para atualizar o agendamento, diz que é uma edicao e envia a funcao para ser executada que ocultará o formulario
      dispatch(
        curriculoAddUpdCandidatoAgenda(
          {
            id_agenda: idAgenda,
            agenda: data,
            envio_email_e_whatsapp,
            mensagem_adicional,
          },
          true,
          () => setAlterarAgenda(null)
        )
      );
    };
  };

  return (
    <Stack sx={{ p: 1, minHeight: "70vh" }}>
      <Typography align="center" variant="h6">
        {tipoAgenda === "minhaAgenda"
          ? "Suas entrevistas agendadas"
          : "Entrevistas agendadas dos outros"}
      </Typography>
      <Typography sx={{ opacity: 0.7 }} align="center" variant="body2">
        'Escolha entre alguma das opções dos dias para ver agendamento de
        entrevistas futuras.'
      </Typography>
      <Grid container spacing={2} sx={{ height: "70vh" }}>
        <Grid item xs={12} sm={3}>
          <Stack spacing={1}>
            {arr.map((ele, idx) => {
              const isChecado = idx === selecionado;
              const icone = isChecado ? <EventAvailableIcon /> : <EventIcon />;
              const variant = isChecado ? "contained" : "text";
              return (
                <Button
                  key={idx}
                  fullWidth
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                  variant={variant}
                  onClick={ele.onClick}
                  startIcon={icone}
                >
                  {ele.texto}
                </Button>
              );
            })}
          </Stack>
        </Grid>
        <Grid item xs={12} sm={9}>
          {diasSelecionados.length === 0 && (
            <Box
              sx={{
                height: "70vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <RetornoEmBranco />
            </Box>
          )}
          {diasSelecionados.map((dia, idx) => {
            // Pega a estrutura de curriculos do dia
            const arr = agenda[dia];
            // Coloca um titulo e faz um loop para listar os curriculos
            return (
              <React.Fragment key={idx}>
                <Typography
                  sx={{ mt: 1 }}
                  variant="subtitle1"
                  fontWeight="bold"
                  align="center"
                >
                  Candidato(s) agendado(s) para o dia &nbsp;
                  {format(parseISO(dia), "dd/MM/yyyy")}
                </Typography>
                {/* Agora passa pelo array de candidatos e exiba seu nome */}
                <Stack>
                  {arr.map((cand, idx2) => (
                    <React.Fragment key={idx2}>
                      <ListItem dense key={idx2} divider>
                        <ListItemText
                          primary={cand.nome}
                          secondary={
                            <>
                              <BotaoContato celular={cand.celular} />
                              <Typography
                                sx={{ display: "flex", alignItems: "flex-end" }}
                                component="p"
                                variant="caption"
                              >
                                <ScheduleIcon /> &nbsp;{" "}
                                {`Agendado(a) para ${format(
                                  parseISO(dia),
                                  "dd/MM/yyyy"
                                )} ${cand.hora} `}
                              </Typography>
                              <Chip
                                sx={{ mt: 1 }}
                                title={`Agendado por: ${
                                  usuarios[cand.agendadoPor].nome
                                }`}
                                size="small"
                                avatar={
                                  <Avatar
                                    alt={cand.agendadoPor}
                                    src={usuarios[cand.agendadoPor].avatar}
                                  />
                                }
                                label={usuarios[cand.agendadoPor].nome}
                              />

                              {isMobile && (
                                <BotoesCandidatoAgendadoMobile
                                  minhaAgenda={tipoAgenda === "minhaAgenda"}
                                  fnDetalhes={() =>
                                    fnDetalhes(
                                      cand.id_curriculo,
                                      cand.id_agenda
                                    )
                                  }
                                  fnAlterar={() =>
                                    setAlterarAgenda((state) =>
                                      state === cand.id_agenda
                                        ? null
                                        : cand.id_agenda
                                    )
                                  }
                                  fnExcluir={() =>
                                    fnRemoverAgendamento(cand.id_agenda)
                                  }
                                />
                              )}
                            </>
                          }
                        />
                        {!isMobile && (
                          <BotoesCandidatoAgendado
                            minhaAgenda={tipoAgenda === "minhaAgenda"}
                            fnDetalhes={() =>
                              fnDetalhes(cand.id_curriculo, cand.id_agenda)
                            }
                            fnAlterar={() =>
                              setAlterarAgenda((state) =>
                                state === cand.id_agenda ? null : cand.id_agenda
                              )
                            }
                            fnExcluir={() =>
                              fnRemoverAgendamento(cand.id_agenda)
                            }
                          />
                        )}
                      </ListItem>
                      {/* {Usado para quando se deseja alterar a data da entrevista} */}
                      <AnimatePresence>
                        {alterarAgenda === cand.id_agenda && (
                          <motion.div
                            key={cand.id_agenda}
                            initial={{ opacity: 0.01, height: 0.01 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ opacity: 0.01, height: 0.01 }}
                            transition={{ duration: 0.3 }}
                          >
                            <Paper sx={{ p: 1 }} elevation={3}>
                              <Container sx={{ my: 2 }} maxWidth="xs">
                                <ComponenteAgendamento
                                  nome={cand.nome}
                                  fn={fnAtualizaAgendamento(cand.id_agenda)}
                                />
                              </Container>
                            </Paper>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </React.Fragment>
                  ))}
                </Stack>
              </React.Fragment>
            );
          })}
        </Grid>
      </Grid>
    </Stack>
  );
};
// Compoente auxiliar para os botoes dos candidatos agendados
const BotoesCandidatoAgendado = ({
  minhaAgenda,
  fnDetalhes,
  fnAlterar,
  fnExcluir,
}) => {
  return (
    <>
      <Button
        size="small"
        sx={{ mr: 1 }}
        variant="contained"
        title="Exiba mais detalhes sobre este currículo"
        startIcon={<ContactPageIcon />}
        onClick={fnDetalhes}
      >
        Detalhes
      </Button>
      {minhaAgenda && (
        <>
          <Button
            size="small"
            sx={{ mr: 1 }}
            variant="outlined"
            title="Altere a data/hora da entrevista"
            startIcon={<ModeEditIcon />}
            onClick={fnAlterar}
          >
            Alterar
          </Button>
          <Button
            size="small"
            title="Exclua este agendamento"
            variant="text"
            startIcon={<EventBusyIcon />}
            onClick={fnExcluir}
          >
            Excluir
          </Button>
        </>
      )}
    </>
  );
};
const BotoesCandidatoAgendadoMobile = ({
  minhaAgenda,
  fnAlterar,
  fnDetalhes,
  fnExcluir,
}) => {
  return (
    <Box sx={{ mt: 1, display: "flex", justifyContent: "space-between" }}>
      <Stack onClick={fnDetalhes}>
        <IconButton color="primary">
          <ContactPageIcon />
        </IconButton>
        <Typography color="primary" variant="caption">
          Detalhes
        </Typography>
      </Stack>
      {minhaAgenda && (
        <>
          <Stack onClick={fnAlterar}>
            <IconButton color="primary">
              <ModeEditIcon />
            </IconButton>
            <Typography color="primary" variant="caption">
              Alterar
            </Typography>
          </Stack>
          <Stack onClick={fnExcluir}>
            <IconButton color="primary">
              <EventBusyIcon />
            </IconButton>
            <Typography color="primary" variant="caption">
              Remover
            </Typography>
          </Stack>
        </>
      )}
    </Box>
  );
};
// Componente para atualização/inclusao de data/hora para agendamento
const ComponenteAgendamento = ({ fn, nome }) => {
  const { aguardar } = useSelector((state) => state);
  //
  const {
    watch,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schemaValidacao),
  });

  return (
    <Grid sx={{ py: 1 }} container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" align="center">
          Agendamento de entrevista
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography sx={{ opacity: 0.5 }} variant="body2" align="center">
          Escolha a data e hora em que você desejará agendar a entrevista com o
          candidato.
        </Typography>
        {nome.length > 0 && (
          <Typography align="center" variant="body1">
            Candidato(a): {nome}
          </Typography>
        )}
      </Grid>
      <Grid item xs={12}>
        <LocalizationProvider locale={ptBR} dateAdapter={AdapterDateFns}>
          <Controller
            name="agenda"
            control={control}
            defaultValue={null}
            rules={{ required: true }}
            render={({ field }) => (
              <DateTimePicker
                {...field}
                inputFormat="dd/MM/yyyy HH:mm"
                label="Data / Hora "
                minDateTime={new Date()}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    helperText={
                      !!errors.agenda &&
                      "Data deve ser superior a data/hora atual (dd/mm/aaaa hh:mm)"
                    }
                    error={!!errors.agenda}
                  />
                )}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12}>
        <Controller
          name="envio_email_e_whatsapp"
          control={control}
          render={({ field }) => (
            <FormControlLabel
              {...field}
              disabled={aguardar}
              control={<Switch />}
              label={
                <Stack direction="row" alignItems="center">
                  <EmailIcon
                    color={
                      watch("envio_email_e_whatsapp") ? "primary" : "default"
                    }
                  />
                  <Typography sx={{ ml: 1 }} variant="body1">
                    Notificar candidato(a) por e-mail e WhatsApp
                  </Typography>
                </Stack>
              }
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <AnimatePresence>
          {watch("envio_email_e_whatsapp") && (
            <motion.div
              key="campo_notificacao_email"
              initial={{ opacity: 0.01 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0.01 }}
              transition={{ duration: 0.3 }}
            >
              <Controller
                name="mensagem_adicional"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    size="small"
                    label="Informações adicionais (opcional)"
                    InputLabelProps={{ shrink: true }}
                    type="textarea"
                    multiline
                    minRows={2}
                    placeholder="Digite alguma informação adicional como local do processo seletivo."
                  />
                )}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </Grid>
      <Grid item xs={12}>
        <Button
          startIcon={
            aguardar ? <CircularProgress size={20} /> : <EventAvailableIcon />
          }
          disabled={aguardar}
          variant="contained"
          onClick={handleSubmit(fn)}
          fullWidth
        >
          Agendar
        </Button>
      </Grid>
    </Grid>
  );
};
// Componente para exibir detalhes de um curriculo
const DetalhesCurriculo = ({
  ocultarBotaoRemoverAgenda,
  detalhes,
  favoritos,
  somenteLeitura,
}) => {
  // Controla o estado de exibicao do campo de observacoes
  const [formOBS, setFormOBS] = useState(null);
  const dispatch = useDispatch();

  const {
    pessoal,
    experiencia_profissional,
    disponibilidade,
    id_curriculo,
    id_agenda,
    cargo_elegivel,
  } = detalhes;
  // Veja se este curiculo e favorito, se ele for nao devemos exibir o botao para favoritar
  const isFav =
    favoritos?.filter((ele) => ele.id.toString() === id_curriculo.toString())
      .length === 1;
  // Pegar a resolucao da tela para saber em qual estamos trabalhando
  const {
    breakpoints: { values },
  } = useTheme();
  const isMobile = values["sm"] > window.innerWidth;

  // Chaveamento para os icones
  const ICONES = {
    Nome: <PersonIcon />,
    "E-mail": <EmailIcon />,
    Celular: <WhatsAppIcon />,
    Idade: <CakeIcon />,
    Filho: <ChildFriendlyIcon />,
    Escolaridade: <SchoolIcon />,
    Endereco: <HomeIcon />,
    Bairro: <HomeIcon />,
    Cidade: <HomeIcon />,
    Estado: <HomeIcon />,
    Número: <HomeIcon />,
    "Inclusao Curriculo": <EventAvailableIcon />,
    Usado: <PermContactCalendarIcon />,
  };
  // Isto quer dizer que os botoes não devem ser criados. Possivelmente estamos na agenda dos outros
  let botoes = [];
  if (!somenteLeitura) {
    // Array com todos os botoes para o que pode ser feito no currículo
    botoes = [
      {
        icone: isFav ? <FavoriteIcon /> : <FavoriteBorderIcon />,
        onClick: () => {
          // Se isFav quer dizer que tem o favorito, entao deve excluir (delete = true)
          dispatch(curriculoAddDelFavorito({ id_curriculo }, isFav));
        },
        texto: isMobile ? "FAV" : "FAVORITAR",
        titulo: "Marcar o currículo como favorito",
      },
      {
        icone: <ThumbUpAltIcon />,
        onClick: (ID_CUR) => {
          // Ativa/desativa a exibicao do form
          if (formOBS === `${ID_CUR}_A`) {
            setFormOBS(null);
          } else {
            setFormOBS(`${ID_CUR}_A`);
          }
          // Envia este candidato para aprovado e solicita atualizacao da agendaVencida
        },
        texto: isMobile ? "APRO" : "APROVAR",
        titulo: "Marcar o currículo como aprovado",
      },
      {
        icone: <ThumbDownOffAltIcon />,
        onClick: (ID_CUR) => {
          // Ativa/desativa a exibicao do form
          if (formOBS === `${ID_CUR}_R`) {
            setFormOBS(null);
          } else {
            setFormOBS(`${ID_CUR}_R`);
          }
        },
        texto: isMobile ? "REPR" : "REPROVAR",
        titulo: "Marcar o currículo como reprovado",
      },
    ];
    // Veja se este botao precisa ser exibido ou nao
    if (!ocultarBotaoRemoverAgenda) {
      //
      botoes.push({
        icone: <AirlineSeatReclineNormalIcon />,
        onClick: (ID_CUR) => {
          // Ativa/desativa a exibicao do form
          if (formOBS === `${ID_CUR}_L`) {
            setFormOBS(null);
          } else {
            setFormOBS(`${ID_CUR}_L`);
          }
        },
        texto: isMobile ? "L. ESP" : "ESPERA",
        titulo: "Mover o currículo para a lista de espera",
      });
      // Ele precisa aparecer isto quer dizer que estamos na rotina de agendamento
      botoes.push({
        icone: <EventBusyIcon />,
        onClick: (ID_AGENDA) => {
          // Ativa/desativa a exibicao das outras opcoes
          if (formOBS === `AGENDA_${ID_AGENDA}`) {
            setFormOBS(null);
          } else {
            setFormOBS(`AGENDA_${ID_AGENDA}`);
          }
        },
        texto: isMobile ? "REM. AG" : "AGENDA",
        titulo: "Retirar o curriculo dos agendamentos",
      });
    }
  }

  return (
    <Stack sx={{ maxHeight: "80vh", p: 1 }}>
      <Container maxWidth="md">
        <Stack sx={{ my: 1 }} direction="row" justifyContent="space-around">
          {botoes.map((btn, idx2) =>
            isMobile ? (
              <Stack key={idx2}>
                <IconButton
                  color="primary"
                  title={btn.titulo}
                  key={idx2}
                  onClick={() => btn.onClick(id_curriculo)}
                >
                  {btn.icone}
                </IconButton>
                <Typography variant="caption" align="center">
                  {btn.texto}
                </Typography>
              </Stack>
            ) : (
              <Button
                variant="contained"
                key={idx2}
                sx={{ mx: 1 }}
                fullWidth
                onClick={() =>
                  btn.onClick(idx2 === 4 ? id_agenda : id_curriculo)
                }
                title={btn.titulo}
                startIcon={btn.icone}
                size="small"
              >
                {btn.texto}
              </Button>
            )
          )}
        </Stack>
        <AnimatePresence>
          {formOBS && formOBS.search("AGENDA") !== -1 ? (
            <ConfirmAgendamento
              fnFecharObs={() => setFormOBS(null)}
              id_agenda={id_agenda}
            />
          ) : formOBS && formOBS.search(id_curriculo.toString()) !== -1 ? (
            <FormJustificarUsoCurriculo
              key="form_just"
              id_curriculo={id_curriculo}
              status={formOBS.split("_")[1]}
              fnFecharObs={() => setFormOBS(null)}
            />
          ) : null}
        </AnimatePresence>
      </Container>
      <br />
      <Divider />
      {disponibilidade && disponibilidade.length > 0 && (
        <Typography variant="h4" align="center">
          Disponibilidade
        </Typography>
      )}
      <Grid sx={{ mb: 1 }} container>
        {disponibilidade.map((ele, idx) => {
          return (
            <Grid item key={idx} xs={12} sm={4}>
              <Typography component="span" variant="subtitle1">
                {ele.regiao} -{" "}
              </Typography>
              <Typography
                fontWeight="bold"
                sx={{ color: "secondary.main" }}
                component="span"
                variant="h6"
              >
                {ele.localidade}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
      <Divider />
      <Typography align="center" variant="h4">
        Informações pessoais
      </Typography>

      <Grid sx={{ p: 1 }} container spacing={2}>
        {Object.keys(pessoal).map((key, idx) => {
          // Formata o valor (quando necessario)
          const valor = ["Inclusao Curriculo"].includes(key)
            ? format(parseISO(pessoal[key]), "dd/MM/yyyy HH:mm")
            : pessoal[key];

          return (
            <Grid key={idx} item xs={12} sm={3}>
              <TextField
                fullWidth
                size="small"
                label={key}
                value={valor}
                InputProps={{
                  startAdornment: Object.keys(ICONES).includes(key)
                    ? ICONES[key]
                    : null,
                }}
              />
            </Grid>
          );
        })}
      </Grid>
      <Divider />
      <Typography align="center" variant="h4">
        Vagas de interesse
      </Typography>

      <Grid sx={{ p: 1 }} container spacing={2}>
        {cargo_elegivel.map((item, idx) => {
          // Formata o valor (quando necessario)
          return (
            <Grid key={idx} item xs={12} sm={4}>
              <Typography color="secondary" variant="h6" fontWeight="bold">
                {item}
              </Typography>
            </Grid>
          );
        })}
      </Grid>
      <Divider />
      <br />
      {experiencia_profissional && experiencia_profissional.length > 0 && (
        <Typography align="center" variant="h4">
          Experiências Profissionais
        </Typography>
      )}
      <div>
        {experiencia_profissional.map((ele, idx) => {
          const { admissao, demissao, cargo, empresa, atividades } = ele;

          return (
            <>
              <Grid sx={{ p: 1 }} container spacing={2} key={idx}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Admissão"
                    value={format(parseISO(admissao), "dd/MM/yyyy")}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Desligamento"
                    value={format(parseISO(demissao), "dd/MM/yyyy")}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Cargo"
                    value={cargo}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Empresa"
                    value={empresa}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Atividades"
                    value={atividades}
                  />
                </Grid>
              </Grid>
              <Divider />
            </>
          );
        })}
      </div>
      <br />
    </Stack>
  );
};
// Componente para exibir a lista de espera recuperada, tanto a minha quanto a dos outros
const ListaDeEspera = ({ tipoLista, usuarios, listaDeEspera }) => {
  const dispatch = useDispatch();
  // Pegar a resolucao da tela para saber em qual estamos trabalhando
  const {
    breakpoints: { values },
  } = useTheme();
  const isMobile = values["sm"] > window.innerWidth;
  // Usar um estado para ativar o campo textarea para inserção da observacao
  const [formOBS, setFormOBS] = useState(null);
  let botoes = [
    {
      icone: <HistoryIcon />,
      texto: isMobile ? "Hist" : "Histórico",
      titulo: "Exibe todas as movimentações deste currículo",
      onClick: (idCur) => {
        // Para ver o historico de um candidato e manter o drawer antigo (este no caso )
        dispatch(curriculoGetHistorico(idCur, true));
      },
    },
  ];
  // Criar a string de titulo baseado no tipo de lista
  const titulo =
    tipoLista === "minhaLista"
      ? "Minha lista de candidatos aguardando meu posicionamento"
      : "Lista geral de candidatos aguardando posicionamento";

  if (tipoLista === "minhaLista") {
    botoes.push({
      icone: <ContactPageIcon />,
      texto: isMobile ? "VER" : "Detalhes",
      titulo: "Exibe os detalhes deste currículo",
      onClick: (idCur) => {
        // Ver detalhes de um curriculo e manter o drawer antigo ( este no caso )
        dispatch(curriculoGetDetalhesCurriculo(idCur, null, true));
      },
    });
    botoes.push({
      icone: <ThumbUpAltIcon />,
      texto: isMobile ? "APR" : "Aprovar",
      titulo: "Aprova o candidato, isto por irá retira-lo da lista de espera",
      onClick: (ID_CUR) => {
        // Ativa/desativa a exibicao do form
        if (formOBS === `${ID_CUR}_A`) {
          setFormOBS(null);
        } else {
          setFormOBS(`${ID_CUR}_A`);
        }
      },
    });
    botoes.push({
      icone: <ThumbDownOffAltIcon />,
      texto: isMobile ? "REP" : "Reprovar",
      titulo: "Reprova o candidato, isto irá retira-lo da lista de espera",
      onClick: (ID_CUR) => {
        // Ativa/desativa a exibicao do form
        if (formOBS === `${ID_CUR}_R`) {
          setFormOBS(null);
        } else {
          setFormOBS(`${ID_CUR}_R`);
        }
      },
    });
    // botoes.push(
    //     {
    //         icone: <DeleteIcon />, texto: isMobile ? 'REM' : 'Remover', titulo: 'Retira o candidato da sua lista de espera',
    //         onClick: (idCur)=>{
    //             dispatch(
    //                 curriculoRemoverCandidatoListaDeEspera({ id_curriculo: idCur })
    //             );
    //         },
    //     }
    // );
  }

  return (
    <Container sx={{ p: 1 }} maxWidth="lg">
      <Stack>
        <Typography
          color="secondary"
          variant="subtitle1"
          fontWeight="bold"
          align="center"
        >
          {titulo}
        </Typography>
        <Typography variant="caption" sx={{ opacity: 0.7 }} align="center">
          Os candidatos aqui estão aguardando uma decisão, se serão aprovados no
          futuro ou reprovados.
        </Typography>
        <Divider />
        <List>
          {listaDeEspera.map((ele) => {
            const {
              emEsperaPor,
              id_curriculo,
              nome,
              sexo,
              celular,
              idade,
              escolaridade,
            } = ele;
            return (
              <ListItem disablePadding divider key={id_curriculo}>
                <ListItemText
                  primary={nome}
                  secondary={
                    <Stack>
                      <Stack
                        direction="row"
                        flexWrap="wrap"
                        justifyContent="flex-start"
                      >
                        <Box sx={{ flexBasis: { xs: "100%" } }}>
                          <BotaoContato celular={celular} />
                        </Box>
                        <Typography
                          sx={{ mx: 1 }}
                          title="Idade do candidato"
                          variant="body2"
                        >
                          <CakeIcon sx={{ mr: 0.5 }} />
                          {idade} anos
                        </Typography>
                        <Typography
                          sx={{ mx: 1 }}
                          title="Sexo do candidato"
                          variant="body2"
                        >
                          {fnGetSexoIcone(sexo)}
                          {fnGetSexo(sexo)}
                        </Typography>
                        <Typography
                          sx={{ mx: 1 }}
                          title="Escolaridade do candidato"
                          variant="caption"
                        >
                          <SchoolIcon sx={{ mr: 0.5 }} />
                          {escolaridade}
                        </Typography>
                      </Stack>
                      <Stack direction="row">
                        <Chip
                          sx={{ mt: 1 }}
                          title={`Inserido na lista de espera por: ${emEsperaPor}`}
                          size="small"
                          avatar={
                            <Avatar
                              alt={emEsperaPor}
                              src={usuarios[emEsperaPor].avatar}
                            />
                          }
                          label={usuarios[emEsperaPor].nome}
                        />
                      </Stack>
                      <Stack
                        sx={{ mt: 1 }}
                        direction="row"
                        justifyContent="space-between"
                      >
                        {botoes.map((ele, idx) => (
                          <Button
                            variant={idx > 2 ? "outlined" : "contained"}
                            sx={{ mx: 0.5 }}
                            key={idx}
                            title={ele.titulo}
                            size="small"
                            onClick={() => ele.onClick(id_curriculo)}
                            startIcon={ele.icone}
                          >
                            {ele.texto}
                          </Button>
                        ))}
                      </Stack>
                      <AnimatePresence>
                        {formOBS &&
                        formOBS.search(id_curriculo.toString()) !== -1 ? (
                          <FormJustificarUsoCurriculo
                            key="form_justi"
                            id_curriculo={id_curriculo}
                            status={formOBS.split("_")[1]}
                            fnFecharObs={() => setFormOBS(null)}
                          />
                        ) : null}
                      </AnimatePresence>
                    </Stack>
                  }
                />
              </ListItem>
            );
          })}
        </List>
      </Stack>
    </Container>
  );
};
// Exibe o historico do curriculo (movimentacoes)
const ListaHistoricoCurriculo = ({ historico }) => {
  return (
    <Container sx={{ py: 1 }} maxWidth="md">
      <Stack>
        <Typography variant="subtitle1" align="center" fontWeight="bold">
          Histórico do candidato
        </Typography>
        <Typography sx={{ opacity: 0.7 }} variant="caption" align="center">
          Todas as movimentações deste candidato no sistema
        </Typography>
        <List>
          {historico.map((ele, idx) => {
            const { usuarioNome, usuarioAvatar, dataHora, observacao, status } =
              ele;
            //
            return (
              <ListItem divider disablePadding key={idx}>
                <ListItemAvatar>
                  <Avatar
                    title={usuarioNome}
                    alt={`Foto de ${usuarioNome}`}
                    src={usuarioAvatar}
                  />
                </ListItemAvatar>
                <ListItemText
                  key={idx}
                  primary={
                    <Stack direction="row">
                      <Typography fontWeight="bold" variant="subtitle2">
                        Status: &nbsp;
                      </Typography>
                      <Typography color="primary" variant="subtitle2">
                        {fnGetTexto(status)}
                      </Typography>
                    </Stack>
                  }
                  secondary={
                    <Stack>
                      <Typography variant="body2">{observacao}</Typography>

                      <Typography
                        component="p"
                        sx={{ my: 0.5 }}
                        //fontWeight='bold'
                        fontStyle="italic"
                        align="left"
                        variant="caption"
                      >
                        <Typography variant="caption" fontWeight="bold">
                          Registrado por: &nbsp;
                        </Typography>
                        {usuarioNome}
                      </Typography>
                      <Typography
                        component="p"
                        color="secondary"
                        //fontWeight='bold'
                        fontStyle="italic"
                        align="right"
                        variant="caption"
                      >
                        <Typography variant="caption" fontWeight="bold">
                          Data movimento:
                        </Typography>
                        {format(parseISO(dataHora), "dd/MM/yy HH:mm")}
                      </Typography>
                    </Stack>
                  }
                />
              </ListItem>
            );
          })}
        </List>
      </Stack>
    </Container>
  );
};
export default Curriculo;
